import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import {
  ItemRelatedGroupsPropType,
  ItemRelatedGroupsDefaultProps,
} from './Helper';

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./ItemRelatedGroupsDesktop')).ItemRelatedGroupsDesktop;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "irg-desktop" */
      './ItemRelatedGroupsDesktop');
  },
  name: 'ItemRelatedGroupsDesktop',
});

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-irg',
  placeholder: (
    <ComponentPlaceholder
      height={400}
      rows={10}
      color="#E0E0E0"
      showLoadingAnimation
    />
  ),
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const ItemRelatedGroupsDesktopImporter = withLayoutGroup({
  name: 'IRG'
}, DynamicComponent);

ItemRelatedGroupsDesktopImporter.displayName = 'ItemRelatedGroupsDesktopImporter';

ItemRelatedGroupsDesktopImporter.propTypes = ItemRelatedGroupsPropType;

ItemRelatedGroupsDesktopImporter.defaultProps = ItemRelatedGroupsDefaultProps;
